import { render, staticRenderFns } from "./DrawingPicture2Text.vue?vue&type=template&id=1b3d8cb2&scoped=true"
import script from "./DrawingPicture2Text.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingPicture2Text.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DrawingPicture2Text.vue?vue&type=style&index=0&id=1b3d8cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d8cb2",
  null
  
)

export default component.exports